const isObject = (value: unknown): value is Record<string, unknown> => {
  return typeof value === 'object' && value !== null;
};

export const isDeepEqual = (firstValue: unknown, secondValue: unknown): boolean => {
  if (Object.is(firstValue, secondValue)) {
    return true;
  }

  if (firstValue instanceof Date && secondValue instanceof Date) {
    return firstValue.getTime() === secondValue.getTime();
  }

  if (Array.isArray(firstValue) || Array.isArray(secondValue)) {
    if (!Array.isArray(firstValue) || !Array.isArray(secondValue) || firstValue.length !== secondValue.length) {
      return false;
    }

    return firstValue.every((item, index) => isDeepEqual(item, secondValue[index]));
  }

  if (!isObject(firstValue) || !isObject(secondValue)) {
    return false;
  }

  const firstKeys = Object.keys(firstValue);
  const secondKeys = Object.keys(secondValue);

  if (firstKeys.length !== secondKeys.length) {
    return false;
  }

  return firstKeys.every(
    (key) =>
      Object.prototype.hasOwnProperty.call(secondValue, key) && isDeepEqual(firstValue[key], secondValue[key as keyof typeof secondValue]),
  );
};
